import { useMutation } from "@tanstack/react-query";
import { HolderService } from "@/generated/services/HolderService";

export function useCreateHolder() {
  return useMutation({
    mutationFn: async (payload: {
      memberId: string;
      waon_inquiry_number?: string;
      encrypted_ref?: string;
    }) => {
      const { memberId, encrypted_ref } = payload;
      const response = HolderService.postMembersHolders(Number(memberId), {
        encrypted_ref: encrypted_ref || undefined,
        retailer_id: Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
      });
      return response;
    },
  });
}

export function useUpdateHolder() {
  return useMutation({
    mutationFn: async (payload: {
      memberId: string;
      holderId?: string;
      waon_inquiry_number?: string;
      encrypted_ref?: string;
    }) => {
      const { memberId, holderId, encrypted_ref } = payload;

      const objectToSend: {
        encrypted_ref?: string;
        retailer_id: number;
      } = {
        encrypted_ref: encrypted_ref || undefined,
        retailer_id: Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
      };

      const response = HolderService.patchMembersHolders(
        Number(memberId),
        Number(holderId),
        objectToSend,
      );
      return response;
    },
  });
}
